import Tooltip from '@components/Tooltip';
import { useTranslation } from 'react-i18next';

function RecentToolTip() {
    const { t } = useTranslation('signIn');
    return (
        <Tooltip visibleKey='signInMethod'
            hideClose
            align='left'
            top={-36}
            left={16} >
            {t('recentLogin')}
        </Tooltip>
    );
}

export default RecentToolTip;
